import { render, staticRenderFns } from "./TheCreditsInfoSummary.vue?vue&type=template&id=1c4d0516&scoped=true"
import script from "./TheCreditsInfoSummary.vue?vue&type=script&lang=js"
export * from "./TheCreditsInfoSummary.vue?vue&type=script&lang=js"
import style0 from "./TheCreditsInfoSummary.vue?vue&type=style&index=0&id=1c4d0516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d0516",
  null
  
)

export default component.exports